import { render, staticRenderFns } from "./ChoiceType.vue?vue&type=template&id=31d54cfb&scoped=true&"
import script from "./ChoiceType.vue?vue&type=script&lang=js&"
export * from "./ChoiceType.vue?vue&type=script&lang=js&"
import style0 from "./ChoiceType.vue?vue&type=style&index=0&id=31d54cfb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31d54cfb",
  null
  
)

export default component.exports